import { getData } from '@/util/Axios'

export const ApiAuth = (axios, baseUrl) => {
  const AuthSignIn = async (payload) => {
    const result = await axios.post('/auth/sign-in', payload)
    const data = getData(result)
    return data
  }

  const AuthAaul = async (payload) => {
    axios.setToken(payload.aaul, 'Bearer')
    const result = await axios.post('/auth/aaul')
    const data = getData(result)
    return data
  }

  const AuthReset = async (email) => {
    await axios.post('/auth/reset-password', { email })
  }

  const AuthBridge = async (payload) => {
    const result = await axios.post('/auth/bridge-login', payload)
    const data = getData(result)
    return data
  }

  const AuthSignOut = async (payload) => {
    await axios.get('/auth/logout')
  }

  return {
    AuthAaul,
    AuthReset,
    AuthBridge,
    AuthSignIn,
    AuthSignOut
  }
}
